import React from "react";
import Rating from "./Rating";
import ProductButtons from "./ProductButtons";
import currency from "currency.js";

const ProductDetail = React.memo(({ product, isOnSale, isInStock }) => {
  return (
    <div className="col-12 col-md-6 pl-lg-10">
      {/* Header */}
      <div className="row mb-1">
        <div className="col">
          <span className="text-muted d-block text-uppercase">
            {product.brand}
          </span>
        </div>
        <div className="col-auto">
          {/* Rating */}
          <Rating rating={product.rating} />

          <a className="font-size-sm text-reset ml-2" href="#reviews">
            Reviews ({product.reviews.length})
          </a>
        </div>
      </div>
      {/* Heading */}
      <h3 className="mb-2">{product.name}</h3>
      {/* Price */}
      <div className="mb-7">
        {isOnSale && (
          <span className="font-size-lg font-weight-bold text-gray-350 text-decoration-line-through">
            {currency(product.compareAtPrice).format()}
          </span>
        )}
        <span className="ml-1 font-size-h5 font-weight-bolder text-primary">
          {currency(product.price).format()}
        </span>
      </div>

      <ProductButtons product={product} />
    </div>
  );
});

export default ProductDetail;
